var mainProduct = function () {

    // Selectors object
    var selectors = {
        productSingleGallery: document.querySelector('[data-product-single-gallery]'),
        productSingleThumbnailGallery: document.querySelector('[data-product-single-thumbnails]'),
        productSingleThumbnails: document.querySelectorAll('[data-product-single-thumbnail]'),
        addToCart: '[data-add-to-cart]',
    };
    
    // Local function name - not available outside this object
    var listeners = function (){
        
        var productSingleGallerySwiper = new Swiper(selectors.productSingleGallery, {
            loop: true,
            spaceBetween: 0,
            slidesPerView: 1.2,
            watchSlidesProgress: true,
            preloadImages: false,
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            breakpoints: {
                989: {
                    slidesPerView: 1,
                }
            }
        });
        productSingleGallerySwiper.on('slideChange', function () {
            let activeIndex = productSingleGallerySwiper.activeIndex
            selectors.productSingleThumbnails.forEach(trigger => {
                if(trigger.dataset.slideIndex == activeIndex){
                    trigger.classList.add('is--active');
                } else{
                    trigger.classList.remove('is--active');
                }
            })
        });

        selectors.productSingleThumbnails.forEach(thumbnail => {
            thumbnail.addEventListener("click", (e) =>{
                let clickedThumbnail = e.target.closest('[data-product-single-thumbnail]');
                let slideIndex = clickedThumbnail.dataset.slideIndex;
                productSingleGallerySwiper.slideTo(slideIndex, 500, false);

                // selectors.productSingleThumbnails.forEach(trigger => {
                //     if(clickedThumbnail !== trigger){
                //         trigger.classList.remove('is--active');
                //     }
                // })
                // clickedThumbnail.classList.add('is--active');
            });
        });
    };

    // listeners();

}();